<template>
  <v-footer class="footer" dark height="auto">
    <v-card flat class="grey darken-3 white--text text-xs-center" min-width="100%">
      <v-card-text>
        <v-btn v-for="icon in icons" :key="icon" class="mx-3 white--text" icon>
          <v-icon size="28px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        <v-container fluid grid-list-xl>
          <v-layout row wrap justify-space-around>
            <v-flex xs12 sm12 md12 xl3 lg3>
              <!-- <div class="font-weight-bold foot-title">دسترسی سریع</div> -->

              <div
                class="text-doc"
              >وبسایت رسمی سافاری</div>
            </v-flex>
            <v-flex xs12 sm12 md12 xl3 lg3>
              <div class></div>
              <div class="font-weight-bold foot-title">دسترسی سریع</div>

              <div>
                <v-btn
                  block
                  flat
                  v-for="(fm,index) in footm1"
                  :key="index"
                  :to="fm.route"
                >{{fm.title}}</v-btn>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md12 xl3 lg3 hidden-xs-only hidden-sm-only>
              <div class="font-weight-bold foot-title">دسترسی سریع</div>
              <div>
                <v-btn
                  block
                  flat
                  v-for="(fm2,index) in footm2"
                  :key="index"
                  :to="fm2.route"
                >{{fm2.title}}</v-btn>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md12 xl3 lg3 hidden-xs-only hidden-sm-only>
              <div class="font-weight-bold foot-title">دسترسی سریع</div>
              <div>
                <v-btn
                  block
                  flat
                  v-for="(fm3,index) in footm3"
                  :key="index"
                  :to="fm3.route"
                >{{fm3.title}}</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{new Date().getFullYear()}} &copy; — 
        <strong>تمامی حقوق این وبسایت برای سافاری محفوظ می باشد</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      footm1: [
        { title: "صفحه اصلی ", route: "i" },
        { title: "خدمات ", route: "" },
        { title: "تماس با ما ", route: "contact" },
        { title: "درباره ما ", route: "about" }
      ],
      footm2: [
        { title: "آخرین خبرها ", route: "" },
        { title: "آخرین مسابقه ها ", route: "" },
        { title: "جدول مسابقات", route: "" },
        { title: "رنک بندی", route: "" }
      ],
      footm3: [
        { title: "about", route: "about" },
        { title: "contact-us ", route: "" },
        { title: "جدول مسابقات", route: "" },
        { title: "رنک بندی", route: "" }
      ]
    };
  }
};
</script>

<style scoped>
</style>
